// FormRow — label + control + helper/error layout primitive. Use for custom
// controls that aren't MUI fields (so they still get consistent label/error
// presentation and the required "*"). MUI TextField/Select already render their
// own label; FormRow is for everything else.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './form-row.css';

export function FormRow({ label, htmlFor, required = false, error, helperText, className, children }) {
  return (
    <div className={cx('form-row', error && 'form-row--error', className)}>
      {label && (
        <label className="form-row__label" htmlFor={htmlFor}>
          {label}
          {required && <span className="form-row__req" aria-hidden="true"> *</span>}
        </label>
      )}
      <div className="form-row__control">{children}</div>
      {(error || helperText) && <p className="form-row__msg">{error || helperText}</p>}
    </div>
  );
}

FormRow.propTypes = {
  label: PropTypes.node,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.node,
  helperText: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FormRow;
